<template>
<m-pageframe
    title="{organization-label}: Order Attribution Settings"
>
<v-container
    fluid
    v-if="settings != null"
    style="padding-left: 15px; padding-right: 15px"
>
    <m-edit-text
        label="Label"
        v-model="settings.label"
        v-on:input="save"
    />

    <v-row
        style="margin-top: -35px"
    >
        <v-col style="max-width: 200px">
            <v-switch
                label="Default settings"
                v-model="settings.is_organization_default"
                v-on:change="save"
            />
        </v-col>
        <v-col class="flex-grow-0">
            <v-switch
                label="Archived"
                v-model="settings.is_archived"
                v-on:change="save"
            />
        </v-col>
    </v-row>
    

    <m-edit-text
        label="Maximum Attributed Opt Out Delay (Days)"
        v-model="settings.opt_out_prox_days"
        integer_positive
        v-on:input="save"
    />

    <m-edit-text
        label="Maximum Attributed Order Delay (Days)"
        v-model="settings.order_prox_days"
        integer_positive
        v-on:input="save"
    />

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    />

    <div
        style="margin-bottom:15px; text-align: right;"
    >
        <a v-on:click="checkAll">Check All</a>&nbsp;&nbsp;
        <a v-on:click="uncheckAll">Uncheck All</a>
    </div>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.value="{ item }">
            <v-simple-checkbox
                :value="item.value"
                v-on:input="onChangeInclude(item, $event)"
            />
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            settings: null,
            full_text: null,

            headers: [
                { text: 'Order Type', value: 'text'},
                { text: 'Include in Order Attribution', value: 'value' },
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/integrations/crm/order/attribution/settings/:order_attribution_settings_id',
            
                'params' : {
                        'order_attribution_settings_id': this.$route.params.order_attribution_settings_id,
                    },
            
                'on_success': (data) => {
                        this.settings = data;
                    },
            
                'on_error': 'Unable to get order attribution settings',
            });
        },

        save() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/crm/order/attribution/settings',
            
                'params' : this.settings,
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to save order attribution settings',
            });
        },

        onChangeInclude(item, value)
        {
            this.settings.include_order_types = this.settings.include_order_types.filter((el) => el != item.text);
            this.settings.exclude_order_types = this.settings.exclude_order_types.filter((el) => el != item.text);

            if ( value )
            {
                this.settings.include_order_types.push(item.text);
            }
            else
            {
                this.settings.exclude_order_types.push(item.text);
            }

            this.save();
        },

        checkAll()
        {
            this.settings.include_order_types = this.settings.include_order_types.concat(this.settings.exclude_order_types);
            this.settings.exclude_order_types = [];
            this.save();
        },

        uncheckAll()
        {
            this.settings.exclude_order_types = this.settings.include_order_types.concat(this.settings.exclude_order_types);
            this.settings.include_order_types = [];
            this.save();
        },
    },


    computed: {
        results() {
            if ( this.settings == null ) 
                return [];
            
            let ret = [];

            this.settings.include_order_types.forEach((el) => ret.push({'text': el, 'value': true}));
            this.settings.exclude_order_types.forEach((el) => ret.push({'text': el, 'value': false}));

            let text_search = (this.full_text ?? '').trim();

            if ( text_search != '' )
            {
                ret = ret.filter((el) => el.text.toLowerCase().includes(text_search.toLowerCase()));
            }

            ret = ret.sort(
                (a,b) => a.text.localeCompare(b.text)
            );

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>